import { render, staticRenderFns } from "./BurnPage.vue?vue&type=template&id=53209bfd&scoped=true&"
import script from "./BurnPage.vue?vue&type=script&lang=js&"
export * from "./BurnPage.vue?vue&type=script&lang=js&"
import style0 from "./BurnPage.vue?vue&type=style&index=0&id=53209bfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53209bfd",
  null
  
)

export default component.exports